import throttle from 'lodash/throttle';

export default {
  data() {
    return {
      throttled: null,
      isMobile: false,
      isMobileOrTablet: false,
      isBigDesktop: true,
      isVeryBigDesktop: false,
    };
  },
  methods: {
    setWidth() {
      const windowWidth = window.innerWidth;
      this.isMobile = windowWidth < 768;
      this.isMobileOrTablet = windowWidth < 992;
      this.isBigDesktop = windowWidth >= 1280;
      this.isVeryBigDesktop = windowWidth > 1680;
    },
  },
  beforeMount() {
    this.setWidth();
  },
  mounted() {
    this.throttled = throttle(this.setWidth, 300);
    window.addEventListener('resize', this.throttled);
  },
  unmounted() {
    window.removeEventListener('resize', this.throttled);
  },
};
